import ccFlywheelFeatureDiscovery from '@post-office/team-package--i18n--cc-flywheel-feature-discovery/i18n/pt-BR.json';
import postOfficeTemplate from '@post-office/team-package--i18n--post-office-template/i18n/pt-BR.json';
import growth from '@post-office/team-package--i18n--growth/i18n/pt-BR.json';
import testMessages from '@post-office/team-package--i18n--test-messages/i18n/pt-BR.json';

export default {
	...ccFlywheelFeatureDiscovery,
	...postOfficeTemplate,
	...growth,
	...testMessages
}
